var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppstore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M57.456 0H14.544C6.507 0 0 6.507 0 14.544v42.921C0 65.493 6.507 72 14.544 72h42.921c8.028 0 14.544-6.507 14.544-14.544V14.544C72 6.507 65.493 0 57.456 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m35.694 16.543 1.458-2.52c.9-1.575 2.907-2.107 4.482-1.207 1.575.9 2.106 2.907 1.206 4.482L28.79 41.617h10.162c3.294 0 5.139 3.87 3.708 6.552H12.87a3.265 3.265 0 0 1-3.276-3.276 3.265 3.265 0 0 1 3.276-3.276h8.352l10.692-18.531-3.34-5.796a3.284 3.284 0 0 1 1.207-4.482 3.285 3.285 0 0 1 4.482 1.206l1.43 2.529zm-12.636 35-3.15 5.464c-.9 1.575-2.907 2.105-4.482 1.206-1.575-.9-2.106-2.907-1.206-4.483l2.34-4.05c2.646-.819 4.797-.188 6.498 1.864zm27.126-9.908h8.523a3.265 3.265 0 0 1 3.276 3.276 3.265 3.265 0 0 1-3.276 3.276h-4.734l3.195 5.544a3.284 3.284 0 0 1-1.206 4.481 3.284 3.284 0 0 1-4.482-1.206c-5.382-9.333-9.423-16.316-12.105-20.97-2.745-4.734-.783-9.486 1.152-11.097 2.15 3.69 5.364 9.261 9.657 16.696z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 36.005,
    x2: 36.005,
    y1: 0,
    y2: 72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18BFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2072F3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h72v72H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppstore);
export default __webpack_public_path__ + "static/media/appstore.a011f4d23382a25b82725cf9c03fb2de.svg";
export { ForwardRef as ReactComponent };